import {List} from "immutable";
import {assert} from "./errors";
import BindingMap from "./binding-map";
import {Maybe} from "ramda-fantasy";
import  * as _ from "ramda";
const Just_645 = Maybe.Just;
const Nothing_646 = Maybe.Nothing;
import {TokenType, TokenClass} from "shift-parser/dist/tokenizer";
function sizeDecending_647(a_648, b_649) {
  if (a_648.scopes.size > b_649.scopes.size) {
    return -1;
  } else if (b_649.scopes.size > a_648.scopes.size) {
    return 1;
  } else {
    return 0;
  }
}
export default class Syntax {
  constructor(token_650, context_651 = {bindings: new BindingMap, scopeset: List()}) {
    this.token = token_650;
    this.context = {bindings: context_651.bindings, scopeset: context_651.scopeset};
    Object.freeze(this.context);
    Object.freeze(this);
  }
  static of(token_652, stx_653 = {}) {
    return new Syntax(token_652, stx_653.context);
  }
  static fromNull(stx_654 = {}) {
    return new Syntax({type: TokenType.NULL, value: null}, stx_654.context);
  }
  static fromNumber(value_655, stx_656 = {}) {
    return new Syntax({type: TokenType.NUMBER, value: value_655}, stx_656.context);
  }
  static fromString(value_657, stx_658 = {}) {
    return new Syntax({type: TokenType.STRING, str: value_657}, stx_658.context);
  }
  static fromPunctuator(value_659, stx_660 = {}) {
    return new Syntax({type: {klass: TokenClass.Punctuator, name: value_659}, value: value_659}, stx_660.context);
  }
  static fromKeyword(value_661, stx_662 = {}) {
    return new Syntax({type: {klass: TokenClass.Keyword, name: value_661}, value: value_661}, stx_662.context);
  }
  static fromIdentifier(value_663, stx_664 = {}) {
    return new Syntax({type: TokenType.IDENTIFIER, value: value_663}, stx_664.context);
  }
  static fromRegularExpression(value_665, stx_666 = {}) {
    return new Syntax({type: TokenType.REGEXP, value: value_665}, stx_666.context);
  }
  static fromBraces(inner_667, stx_668 = {}) {
    let left_669 = new Syntax({type: TokenType.LBRACE, value: "{"});
    let right_670 = new Syntax({type: TokenType.RBRACE, value: "}"});
    return new Syntax(List.of(left_669).concat(inner_667).push(right_670), stx_668.context);
  }
  static fromBrackets(inner_671, stx_672 = {}) {
    let left_673 = new Syntax({type: TokenType.LBRACK, value: "["});
    let right_674 = new Syntax({type: TokenType.RBRACK, value: "]"});
    return new Syntax(List.of(left_673).concat(inner_671).push(right_674), stx_672.context);
  }
  static fromParens(inner_675, stx_676 = {}) {
    let left_677 = new Syntax({type: TokenType.LPAREN, value: "("});
    let right_678 = new Syntax({type: TokenType.RPAREN, value: ")"});
    return new Syntax(List.of(left_677).concat(inner_675).push(right_678), stx_676.context);
  }
  resolve() {
    if (this.context.scopeset.size === 0 || !(this.isIdentifier() || this.isKeyword())) {
      return this.token.value;
    }
    let scope_679 = this.context.scopeset.last();
    let stxScopes_680 = this.context.scopeset;
    let bindings_681 = this.context.bindings;
    if (scope_679) {
      let scopesetBindingList = bindings_681.get(this);
      if (scopesetBindingList) {
        let biggestBindingPair = scopesetBindingList.filter(({scopes, binding}) => {
          return scopes.isSubset(stxScopes_680);
        }).sort(sizeDecending_647);
        if (biggestBindingPair.size >= 2 && biggestBindingPair.get(0).scopes.size === biggestBindingPair.get(1).scopes.size) {
          let debugBase = "{" + stxScopes_680.map(s_682 => s_682.toString()).join(", ") + "}";
          let debugAmbigousScopesets = biggestBindingPair.map(({scopes}) => {
            return "{" + scopes.map(s_683 => s_683.toString()).join(", ") + "}";
          }).join(", ");
          throw new Error("Scopeset " + debugBase + " has ambiguous subsets " + debugAmbigousScopesets);
        } else if (biggestBindingPair.size !== 0) {
          let bindingStr = biggestBindingPair.get(0).binding.toString();
          if (Maybe.isJust(biggestBindingPair.get(0).alias)) {
            return biggestBindingPair.get(0).alias.getOrElse(null).resolve();
          }
          return bindingStr;
        }
      }
    }
    return this.token.value;
  }
  val() {
    assert(!this.isDelimiter(), "cannot get the val of a delimiter");
    if (this.isStringLiteral()) {
      return this.token.str;
    }
    if (this.isTemplate()) {
      return this.token.items.map(el_684 => {
        if (el_684 instanceof Syntax && el_684.isDelimiter()) {
          return "${...}";
        }
        return el_684.slice.text;
      }).join("");
    }
    return this.token.value;
  }
  lineNumber() {
    if (!this.isDelimiter()) {
      return this.token.slice.startLocation.line;
    } else {
      return this.token.get(0).lineNumber();
    }
  }
  setLineNumber(line_685) {
    let newTok_686 = {};
    if (this.isDelimiter()) {
      newTok_686 = this.token.map(s_687 => s_687.setLineNumber(line_685));
    } else {
      for (let key of Object.keys(this.token)) {
        newTok_686[key] = this.token[key];
      }
      assert(newTok_686.slice && newTok_686.slice.startLocation, "all tokens must have line info");
      newTok_686.slice.startLocation.line = line_685;
    }
    return new Syntax(newTok_686, this.context);
  }
  inner() {
    assert(this.isDelimiter(), "can only get the inner of a delimiter");
    return this.token.slice(1, this.token.size - 1);
  }
  addScope(scope_688, bindings_689, options_690 = {flip: false}) {
    let token_691 = this.isDelimiter() ? this.token.map(s_693 => s_693.addScope(scope_688, bindings_689, options_690)) : this.token;
    if (this.isTemplate()) {
      token_691 = {type: this.token.type, items: token_691.items.map(it_694 => {
        if (it_694 instanceof Syntax && it_694.isDelimiter()) {
          return it_694.addScope(scope_688, bindings_689, options_690);
        }
        return it_694;
      })};
    }
    let newScopeset_692;
    if (options_690.flip) {
      let index = this.context.scopeset.indexOf(scope_688);
      if (index !== -1) {
        newScopeset_692 = this.context.scopeset.remove(index);
      } else {
        newScopeset_692 = this.context.scopeset.push(scope_688);
      }
    } else {
      newScopeset_692 = this.context.scopeset.push(scope_688);
    }
    return new Syntax(token_691, {bindings: bindings_689, scopeset: newScopeset_692});
  }
  removeScope(scope_695) {
    let token_696 = this.isDelimiter() ? this.token.map(s_699 => s_699.removeScope(scope_695)) : this.token;
    let newScopeset_697 = this.context.scopeset;
    let index_698 = this.context.scopeset.indexOf(scope_695);
    if (index_698 !== -1) {
      newScopeset_697 = this.context.scopeset.remove(index_698);
    }
    return new Syntax(token_696, {bindings: this.context.bindings, scopeset: newScopeset_697});
  }
  isIdentifier() {
    return !this.isDelimiter() && this.token.type.klass === TokenClass.Ident;
  }
  isAssign() {
    return !this.isDelimiter() && this.token.type === TokenType.ASSIGN;
  }
  isBooleanLiteral() {
    return !this.isDelimiter() && this.token.type === TokenType.TRUE || this.token.type === TokenType.FALSE;
  }
  isKeyword() {
    return !this.isDelimiter() && this.token.type.klass === TokenClass.Keyword;
  }
  isNullLiteral() {
    return !this.isDelimiter() && this.token.type === TokenType.NULL;
  }
  isNumericLiteral() {
    return !this.isDelimiter() && this.token.type.klass === TokenClass.NumericLiteral;
  }
  isPunctuator() {
    return !this.isDelimiter() && this.token.type.klass === TokenClass.Punctuator;
  }
  isStringLiteral() {
    return !this.isDelimiter() && this.token.type.klass === TokenClass.StringLiteral;
  }
  isRegularExpression() {
    return !this.isDelimiter() && this.token.type.klass === TokenClass.RegularExpression;
  }
  isTemplate() {
    return !this.isDelimiter() && this.token.type === TokenType.TEMPLATE;
  }
  isDelimiter() {
    return List.isList(this.token);
  }
  isParens() {
    return this.isDelimiter() && this.token.get(0).token.type === TokenType.LPAREN;
  }
  isBraces() {
    return this.isDelimiter() && this.token.get(0).token.type === TokenType.LBRACE;
  }
  isBrackets() {
    return this.isDelimiter() && this.token.get(0).token.type === TokenType.LBRACK;
  }
  isSyntaxTemplate() {
    return this.isDelimiter() && this.token.get(0).val() === "#`";
  }
  isEOF() {
    return !this.isDelimiter() && this.token.type === TokenType.EOS;
  }
  toString() {
    if (this.isDelimiter()) {
      return this.token.map(s_700 => s_700.toString()).join(" ");
    }
    if (this.isStringLiteral()) {
      return "'" + this.token.str;
    }
    if (this.isTemplate()) {
      return this.val();
    }
    return this.token.value;
  }
}
